import { jsonMember, jsonObject } from 'typedjson';

@jsonObject
export class AdminOrderShipmentContextOperationsResponse {
  @jsonMember(Boolean)
  public readonly canBeSent!: boolean;

  @jsonMember(Boolean)
  public readonly canBeDeleted!: boolean;

  @jsonMember(Boolean)
  public readonly canBeEdited!: boolean;
}
